// Eskom PARCC — select the reviewed transactions for the admin bulk
// working-paper download (owner feedback point 7: "download working papers for
// all reviewed transactions").
//
// Pure: a transaction counts as reviewed when its explicit `reviewed` flag is
// set OR its review status is "Reviewed" (case-insensitive) — mirroring
// editTransaction.isReviewed — and it is not soft-deleted. The caller hands the
// result to buildComplianceSheets for the per-route workbook.
import type { Transaction } from '../../data/types';

export function selectReviewedTransactions(transactions: readonly Transaction[]): Transaction[] {
  return transactions.filter((t) => {
    if (t.deleted) return false;
    if (t.reviewed === true) return true;
    return String(t.reviewStatus ?? '').trim().toLowerCase() === 'reviewed';
  });
}
